(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grilboss-scroll-universe-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.section-grilboss-space-v2').forEach((section) => {

    const root = section.querySelector('.gb-space');
    const canvas = section.querySelector('.gb-space__canvas');
    const context = canvas.getContext('2d', { alpha: false });
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const stars = [];
    const earthImage = new Image();
    earthImage.decoding = 'async';
    earthImage.src = root.dataset.earthSrc;
    let width = 0;
    let height = 0;
    let pixelRatio = 1;
    let progress = 0;
    let targetProgress = 0;
    let lastProgressTime = Date.now();
    let visible = true;
    let frame = 0;

    const randomizeStar = (star, initial = false) => {
      star.x = (Math.random() - .5) * width * 2.2;
      star.y = (Math.random() - .5) * height * 2.2;
      star.z = initial ? Math.random() * width + 1 : width;
      star.size = Math.random() * 1.35 + .3;
      star.twinkle = Math.random() * Math.PI * 2;
    };

    const resize = () => {
      width = window.innerWidth;
      height = window.innerHeight;
      pixelRatio = Math.min(window.devicePixelRatio || 1, 1.7);
      canvas.width = Math.round(width * pixelRatio);
      canvas.height = Math.round(height * pixelRatio);
      canvas.style.width = `${width}px`;
      canvas.style.height = `${height}px`;
      context.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);

      const desiredCount = Math.min(900, Math.max(260, Math.round(width * height / 1500)));
      stars.length = 0;
      for (let index = 0; index < desiredCount; index += 1) {
        const star = {};
        randomizeStar(star, true);
        stars.push(star);
      }
    };

    const drawEarth = (amount) => {
      if (amount < .48) return;
      const phase = (amount - .48) / .52;
      const dive = Math.max(0, (amount - .7) / .3);
      const radius = Math.max(2, phase * phase * Math.min(width, height) * .34 * (1 + dive * dive * 10));
      const x = width * .5;
      const y = height * (.58 - phase * .08);

      if (earthImage.complete && earthImage.naturalWidth > 0) {
        const imageSize = radius * 2.45;
        context.save();
        context.globalAlpha = Math.min(1, phase * 1.6) * Math.max(0, 1 - Math.max(0, (amount - .82) / .06));
        context.shadowColor = 'rgb(84 155 194 / .34)';
        context.shadowBlur = Math.max(8, radius * .08);
        context.drawImage(earthImage, x - imageSize / 2, y - imageSize / 2, imageSize, imageSize);
        context.restore();
      }
    };

    const render = (time = 0) => {
      context.fillStyle = '#030305';
      context.fillRect(0, 0, width, height);

      const speed = reducedMotion ? 0 : .7 + progress * 18;
      const focal = width * (.38 + progress * .45);
      const galaxyFade = Math.min(1, Math.max(0, (.84 - progress) / .12));

      stars.forEach((star) => {
        star.z -= speed;
        if (star.z < 1) randomizeStar(star);

        const scale = focal / star.z;
        const x = star.x * scale + width / 2;
        const y = star.y * scale + height / 2;
        if (x < -30 || x > width + 30 || y < -30 || y > height + 30) {
          randomizeStar(star);
          return;
        }

        const previousScale = focal / (star.z + speed * (2 + progress * 5));
        const previousX = star.x * previousScale + width / 2;
        const previousY = star.y * previousScale + height / 2;
        const alpha = Math.min(1, .28 + scale * .14)
          * (.78 + Math.sin(time * .002 + star.twinkle) * .22)
          * galaxyFade;

        context.beginPath();
        context.moveTo(previousX, previousY);
        context.lineTo(x, y);
        context.strokeStyle = `rgb(238 242 247 / ${alpha})`;
        context.lineWidth = Math.min(2.2, star.size * Math.max(.55, scale * .12));
        context.stroke();
      });

      drawEarth(progress);
    };

    const updateProgress = () => {
      const bounds = root.getBoundingClientRect();
      const distance = root.offsetHeight - window.innerHeight;
      targetProgress = Math.min(1, Math.max(0, -bounds.top / Math.max(distance, 1)));
      const now = Date.now();
      const elapsed = Math.min(100, now - lastProgressTime);
      lastProgressTime = now;
      const smoothing = reducedMotion ? 1 : 1 - Math.exp(-elapsed / 115);
      progress += (targetProgress - progress) * smoothing;
      root.style.setProperty('--space-progress', progress.toFixed(4));
    };

    const animate = (time) => {
      if (visible) {
        updateProgress();
        render(time);
      }
      frame = window.requestAnimationFrame(animate);
    };

    const observer = new IntersectionObserver(([entry]) => {
      visible = entry.isIntersecting;
    }, { rootMargin: '120px 0px' });

    resize();
    observer.observe(root);
    frame = window.requestAnimationFrame(animate);
    window.addEventListener('resize', resize, { passive: true });

    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target.contains(root)) {
        window.cancelAnimationFrame(frame);
        observer.disconnect();
      }
    });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grilboss-scroll-universe"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.gb-universe');

    sections.forEach((section) => {
      if (section.dataset.ready === 'true') return;
      section.dataset.ready = 'true';

      const canvas = section.querySelector('.gb-universe__canvas');
      const context = canvas.getContext('2d', { alpha: true });
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let stars = [];
      let visible = true;
      let ticking = false;

      const random = (seed) => {
        const value = Math.sin(seed * 999) * 43758.5453;
        return value - Math.floor(value);
      };

      const resize = () => {
        const ratio = Math.min(window.devicePixelRatio || 1, 1.5);
        canvas.width = Math.round(canvas.clientWidth * ratio);
        canvas.height = Math.round(canvas.clientHeight * ratio);
        context.setTransform(ratio, 0, 0, ratio, 0, 0);
        stars = Array.from({ length: window.innerWidth < 750 ? 80 : 150 }, (_, index) => ({
          x: random(index + 1) * canvas.clientWidth,
          y: random(index + 101) * canvas.clientHeight,
          z: .2 + random(index + 201) * .8,
          size: .35 + random(index + 301) * 1.15
        }));
      };

      const render = (progress) => {
        const width = canvas.clientWidth;
        const height = canvas.clientHeight;
        const centerX = width / 2;
        const centerY = height / 2;
        context.clearRect(0, 0, width, height);

        stars.forEach((star) => {
          const travel = progress * 2.5;
          const depth = Math.max(.08, (star.z - travel * .34 + 1) % 1);
          const scale = 1 / depth;
          const x = centerX + (star.x - centerX) * scale;
          const y = centerY + (star.y - centerY) * scale;
          if (x < -20 || x > width + 20 || y < -20 || y > height + 20) return;
          const alpha = Math.min(.78, (1 - depth) * .72 + .08);
          context.beginPath();
          context.fillStyle = `rgba(235,235,230,${alpha})`;
          context.arc(x, y, star.size * scale * .55, 0, Math.PI * 2);
          context.fill();
        });
      };

      const update = () => {
        ticking = false;
        if (!visible) return;
        const rect = section.getBoundingClientRect();
        const distance = section.offsetHeight - window.innerHeight;
        const progress = Math.min(1, Math.max(0, -rect.top / Math.max(distance, 1)));
        section.style.setProperty('--gb-progress', progress.toFixed(4));
        render(reducedMotion ? 0 : progress);
      };

      const requestUpdate = () => {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(update);
        }
      };

      const observer = new IntersectionObserver((entries) => {
        visible = entries[0].isIntersecting;
        if (visible) requestUpdate();
      }, { rootMargin: '100px 0px' });

      observer.observe(section);
      resize();
      update();
      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', () => { resize(); requestUpdate(); }, { passive: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
